export default __webpack_public_path__ + "static/media/donate-solid.42d9c88b.svg";